import React from "react"
import { StaticQuery, graphql } from "gatsby"

const PeopleQuery = ({ render: Render }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulPerson {
          edges {
            node {
              id
              firstName
              lastName
              role
              isExec
              photo {
                resize(width: 1000) {
                  src
                }
              }
              editableContent {
                json
              }
            }
          }
        }
      }
    `}
    render={data => {
      const people = data.allContentfulPerson.edges.map(({ node }) => node) || []
      return <Render data={{ people }} />
    }}
  />
)

export default PeopleQuery
